/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import Axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import {
  navigateToNextCell,
  onCellFocused,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import ModalDialog from '../../../../SharedModules/Dialog/ModalDialog';
import * as serviceEndPoint from '../../../../SharedModules/services/service';
import Grid from '../../../../SharedModules/Table/TableGridWithFeatures';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import {
  groupTableHead,
  rebateProgramTableHead,
} from '../../client/Components/gridComponents/tableHead';
import { ClientHead } from '../../Plan/component/tableHead';
import {
  dispatchSelectedGroup,
  setAddGroup,
  setClientDataAction,
  setGroupDetailsAndParticptionDates,
  setGroupTabDataAction,
  setSelectedClientAction,
} from '../store/group-action';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';
import { DOUBLE_CLICK_GRID_MSG } from '../../../../SharedModules/Errors/constantMessageData';
import { redirectURLLink } from '../../../../SharedModules/CommonUtilities/commonUtilities';

export const getGroupDetails = async (groupId, clientId, history, dispatch) => {
  dispatch(setAddGroup(false));
  dispatch(setGroupDetailsAndParticptionDates(groupId, clientId, true));

  dispatch(
    setGroupTabDataAction({ tabValue: 'one', disableSaveAndCancel: false })
  );
  redirectURLLink('/group-maintain', 'Maintain Group', history, dispatch);
};

const GroupTableContainer = ({
  selectedClient,
  fullScreenView,
  setFullScreenView,
}) => {
  const gridRef = useRef(0);
  const reduxDataSearchScreen = useSelector(
    (state) => state.sharedState.GroupReducer.searchScreen
  );

  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);
  const history = useHistory();
  const [multiGroup, setMultiGroup] = useState({
    open: false,
    rowData: null,
    tableData: [],
  });
  const [totalCount, setTotalCount] = useState(0);
  const dispatch = useDispatch();
  const clientData = useSelector(
    (state) => state.sharedState.GroupReducer.clientData
  );

  const closeMultiGroup = (value) => {
    if (value) {
      setMultiGroup({ ...multiGroup, open: value });
    } else {
      setMultiGroup({ open: value, rowData: null, tableData: [] });
    }
  };

  const setClientDatInRedux = (data) => {
    dispatch(setClientDataAction(data));
  };

  useEffect(() => {
    if (gridRef?.current?.api && setTotalCount) {
      const count = gridRef?.current?.api?.getDisplayedRowCount();
      setTotalCount(count);
    }
  });

  const getClients = () => {
    Axios.get(serviceEndPoint.CLIENT_FROM_CGP)
      .then((response) => {
        const data = response.data.clientList;
        const numbers = data?.filter(
          (element) => !isNaN(element.clientId.trim())
        );
        const strings = data?.filter((element) =>
          isNaN(element.clientId.trim())
        );
        if (response.data && response.data.clientList) {
          setClientDatInRedux([...numbers, ...strings]);
        }
      })
      .catch((error) => {
        setClientDatInRedux([]);
      });
  };

  const getAllGroupByRebateProgramCode = (rowData) => {
    Axios.post(serviceEndPoint.GET_ALL_GROUPS_BY_REBATE_PROGRAM_CODE, rowData)
      .then((response) => {
        if (response.data && response.data.data) {
          if (response.data.data.length > 1) {
            setMultiGroup({
              open: true,
              rowData,
              tableData: response.data.data,
            });
          } else {
            const data = response.data.data[0];
            getGroupDetails(data.groupId, data.clientId, history, dispatch);
          }
        }
      })
      .catch((error) => {});
  };

  const getAllGroupByClient = (rowData) => {
    Axios.post(serviceEndPoint.GET_ALL_GROUP, rowData)
      .then((response) => {
        if (response.data.data.length > 1) {
          setMultiGroup({ open: true, rowData, tableData: response.data.data });
        } else {
          const data = response.data.data[0];
          getGroupDetails(data.groupId, rowData.clientId, history, dispatch);
        }
      })
      .catch((error) => {});
  };

  const handleViewHistory = (gridApi) => {
    const selectedRow = gridApi.getSelectedRows()?.[0]?.dispSeqNum;
    if (selectedRow !== undefined) {
      setShowViewHistory(true);
      setKeyValue({ DISP_SEQ_NUM: selectedRow });
    }
  };

  const getGroups = () => {
    Axios.get(serviceEndPoint.GET_ALL_GROUPS)
      .then((response) => {
        const data = response.data.data;
        const numbers = data?.filter(
          (element) => !isNaN(element.groupId.trim())
        );
        const strings = data?.filter((element) =>
          isNaN(element.groupId.trim())
        );
        if (response.data && response.data.data) {
          setClientDatInRedux([...numbers, ...strings]);
        }
      })
      .catch((error) => {
        setClientDatInRedux([]);
      });
  };

  const getRebateProgram = () => {
    Axios.post(serviceEndPoint.GET_ALL_GROUPS_BY_REBATE_PROGRAM)
      .then((response) => {
        if (response.data && response.data.data) {
          setClientDatInRedux(response.data.data);
        }
      })
      .catch((error) => {
        setClientDatInRedux([]);
      });
  };

  useEffect(() => {
    if (selectedClient === 'Rebate Program Code') {
      getRebateProgram();
    } else if (selectedClient === 'Client') {
      getClients();
    } else {
      getGroups();
    }
  }, [selectedClient]);

  const handleFullScreenView = () => {
    setFullScreenView(!fullScreenView);
  };
  // handing by default first row selection function
  const onGridReady = (params) => {
    params.api.forEachNode(
      (node) =>
        node.rowIndex === reduxDataSearchScreen?.currentIndex &&
        node.setSelected(true)
    );
  };
  return (
    <div className="table-container">
      {!fullScreenView && <div className="devider-line pb-4" />}
      <TableGrid
        ref={gridRef}
        rowData={clientData}
        gridCall={onGridReady}
        defaultCol={{ editable: false }}
        columnDefs={
          selectedClient === 'Rebate Program Code'
            ? rebateProgramTableHead
            : selectedClient === 'Client'
            ? ClientHead
            : groupTableHead
        }
        cellClickedListener={(e) => {
          dispatch(
            setSelectedClientAction({
              ...reduxDataSearchScreen,
              currentIndex: e?.rowIndex,
            })
          );
          dispatch(dispatchSelectedGroup(e.data));
          if (selectedClient === 'Group') {
            getGroupDetails(e.data.groupId, e.data.clientId, history, dispatch);
          } else if (selectedClient === 'Rebate Program Code') {
            getAllGroupByRebateProgramCode(e.data);
          } else {
            getAllGroupByClient(e.data);
          }
        }}
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        navigateToNextCell={navigateToNextCell}
        tabToNextCell={tabToNextCell}
        enterMovesDown
        suppressCellFocus
        onCellFocused={onCellFocused}
        exportFile
        helpMessage={DOUBLE_CLICK_GRID_MSG}
        data-testid="onEditingStopped"
        fileName="Group"
        gridHeight={fullScreenView ? 'auto' : 350}
      />
      <ModalDialog
        open={multiGroup?.open}
        closeModal={closeMultiGroup}
        grid={
          <Grid
            isModalTable
            gridHeight="270px"
            rowData={multiGroup?.tableData}
            defaultCol={{ editable: false }}
            columnDefs={groupTableHead}
            cellClickedListener={(e) => {
              if (selectedClient === 'Rebate Program Code') {
                getGroupDetails(
                  e.data.groupId,
                  e.data.clientId,
                  history,
                  dispatch
                );
              } else {
                getGroupDetails(
                  e.data.groupId,
                  multiGroup?.rowData?.clientId,
                  history,
                  dispatch
                );
              }
            }}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            handleViewHistory={handleViewHistory}
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            exportFile
            data-testid="onEditingStopped"
            fileName="Group_rebate_client"
            helpMessage={DOUBLE_CLICK_GRID_MSG}
          />
        }
        totalCount={totalCount}
        dialogTitle="Choose a Group"
        cancelAction={closeMultiGroup}
      />
      {showViewHistory ? (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName="Code_Domain_Table"
          keyValue={keyValue}
        />
      ) : null}
    </div>
  );
};

export default GroupTableContainer;
